import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";
import { formatDate, IconButton } from "../../Components/InputElements";
import { currentDateAndTime, decodeData } from '../../Constants/constants';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { useLocation } from "react-router-dom";

function EmployeeOffboard() {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];

    const [loading, setLoading] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [loadingImportExcel, setLoadingImportExcel] = useState(false);
    const [offboardingData, setOffboardingData] = useState([]);
    const [offboardingResponse, setOffboardingResponse] = useState({});
    const [allSheetChecked, setAllSheetChecked] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [allPages, setAllPages] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [uploadSheets, setUploadSheet] = useState({
        file: null,
        remarks: "",       
    });

    const downloadButton = async (id, excelName) => {
        setLoadingDownload(id);
        try {
            const date = currentDateAndTime();
            const response = await fetch(`${apiURL}Employees/DownloadOnboardExcel/${id}`, {
                headers: apiHeaderJSON,
                params:{
                    date: currentDateAndTime()
                }
               
            });

            // Check if the response is okay
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Extract the filename from the Content-Disposition header
            const contentDisposition = response.headers.get('Content-Disposition');
            let fileName = excelName || 'default.xlsx'; // Use provided excelName or default filename

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1]; // Extract the filename
                }
            }

            // Create a blob and download the file
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Use the extracted filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setSuccessMsg("Excel Downloaded Successfully!!");
            setLoadingDownload(false);

            // Clean up the URL object
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingDownload(false);
            setErrorMsg("There was a problem with the download!! Please try again later.");
        }
    }


    const getEmployeeOffboardingData = () => {

        let options = {
            url: `${apiURL}Employees/GetEmployeeOffboardExcelFiles?limit=${limit}&page=${page}`,
            method: "GET",
            headers: apiHeaderJSON,
        }
        axios(options)
            .then((response) => {
                // console.log("getEmployeeOffboardingData ~ response", response?.data);
                let res = response?.data;
                if (response.data.success === true) {
                    // console.log("getEmployeeOffboardingData ~ res", res);
                    setOffboardingData(res?.data);
                    setOffboardingResponse(res);
                    setPage(res?.page);
                    setAllPages(res?.total_pages);
                    setTotalRecords(parseInt(res?.total_records));
                    // setSuccessMsg(response?.data?.message);
                }
                else if (response.data.success === false) {
                    setErrorMsg(response?.data?.message);
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.log(e);
                setErrorMsg(e?.data?.message);

            });

    }
    useEffect(() => {
        setLoading(true);
        getEmployeeOffboardingData();
        
    },[]);

    const handleDeleteExcel = (id) => {
        const options = {
            url: `${apiURL}Employees/DeleteOnboardExcel/${id}`,
            method: "DELETE",
            headers: apiHeaderJSON,
            params:{
                date: currentDateAndTime()
            }
        }
        Swal.fire({
            title: "Are you sure?",
            text: `If you delete this file, You won't able to revert this!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete!",
            cancelButtonText: "No, Cancel!",
            allowOutsideClick: false,
          }).then((result) => {
        if (result.isConfirmed) {
            setLoadingDelete(id);
            axios(options)
            .then((response) => {
                // console.log("getEmployeeOffboardingData ~ response", response?.data);
                let res = response?.data;
                if (response.data.success === true) {
                    console.log("handleDeleteExcel ~ res", res);
                    setSuccessMsg("Excel Deleted Successfully!!");
                    getEmployeeOffboardingData();
                }
                else if (response.data.success === false) {
                    setErrorMsg(response?.data?.message);
                }

                setLoadingDelete(false);
            })
            .catch((e) => {
                console.log(e);
                setErrorMsg(e?.data?.message);
                setLoadingDelete(false);
            });
            }
        })

    }

    const handleExcelDownload = async () => {
        const headers = apiHeaderJSON;
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
       
        axios.get(`${apiURL}Employees/ExportOffboardingTemplate`, {
            headers,
            params:{
                date: currentDateAndTime()
            }
            
        })
            .then(async (response) => {
                const { success, Onboarding_template, message } = response.data;

                if (success === true) {
                    // Create a new workbook
                    const workbook = XLSX.utils.book_new();

                    // Function to create worksheet for a category
                    const createWorksheet = (dataArray, sheetName) => {
                        let worksheetArray = [];

                        // If it's a 2D array, map each sub-array
                        if (Array.isArray(dataArray[0])) {
                            dataArray.forEach(subArray => {
                                worksheetArray.push(subArray);
                            });
                        } else {
                            // Otherwise, just use the single array
                            worksheetArray.push(dataArray);
                        }

                        const worksheet = XLSX.utils.aoa_to_sheet(worksheetArray);
                        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                    };

                    // Onboarding template Sheet
                    if (Onboarding_template) {
                        createWorksheet(Onboarding_template, 'OffboardingDetails');
                    }

                    const file_name = `Employee Offboard Excel.xlsx`;

                    // Write the workbook to an Excel file
                    XLSX.writeFile(workbook, file_name);

                    Swal.close();
                    Swal.fire({
                        title: `<strong>Success</strong>`,
                        text: message,
                        icon: 'success',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    });
                } else {
                    Swal.close();
                    Swal.fire({
                        title: `<strong>Failed</strong>`,
                        text: message,
                        icon: 'error',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    });
                }
            })
            .catch((error) => {
                Swal.close();
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: error.response ? error.response.message : error.message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            });
    };


    function uploadEmployee() {
        setLoadingImportExcel(true);
        let data = {
            ...uploadSheets,
            date: currentDateAndTime(),
        }
        let header = {
            // Accept: "application/json",
            ...apiHeaderFile,
        }
        // console.log("=====>>>", data);
        console.log("uploadEmployee ~ data", data);
        const options = {
            url: `${apiURL}Employees/UploadEmployeeOffboardingDetails`,
            method: "POST",
            headers: header,
            data: data,
        }
        axios(options)
            .then((response) => {
                console.log("=======>>>>>response", response);
                if (response?.data?.success === true) {
                    setSuccessMsg(response?.data?.message);
                    // setTimeout(() => {
                    //     setSuccessMsg(false);
                    // }, 5000);
                    getEmployeeOffboardingData();
                    setAllSheetChecked(false);
                    setUploadSheet({
                        file: null,
                        remarks: "",
                    });
                }
                else if (response?.data?.success === false) {
                    setErrorMsg(response?.data?.message || "There is a problem to upload excel!!");
                    // setTimeout(() => {
                    //     setErrorMsg(false);
                    // }, 5000);
                }

                setLoadingImportExcel(false);
            })
            .catch((e) => {
                console.log(e);
                setLoadingImportExcel(false);
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (uploadSheets.file

        ) {
            uploadEmployee();

        }
        else if (
            !uploadSheets.file
        ) {
            setErrorMsg("Please select excel file to upload data.");
        }
    }

    const handlePrev = () => {
        if (offboardingResponse?.prev === true) {
            if (page > 1) {
                setPage(page - 1);
            }
        }
    };
    const handleNext = () => {
        if (offboardingResponse?.next === true) {
            if (allPages > page) {
                setPage(page + 1);
            }
        }
    };


    const handleLimitChange = (e) => {
        setLimit(e.target.value);
    };

    useEffect(() => {
        getEmployeeOffboardingData();
    }, [limit, page])

    // console.log("success", successMsg);

    return (
        <section>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Employee Offboarding`} primary={`Home`} />

                            <div className="card">
                                <div className="card-body">
                                    { decodedData?.includes(6) && (
                                        <>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label >File Upload</label>
                                                    <div className="input-group">
                                                        <input type="file" onChange={(e) => { setUploadSheet({ ...uploadSheets, file: e.target.files[0] }) }} accept=".xlsx" className="form-control" name="fileUpload" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="File Upload" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label >Remarks</label>
                                                    <div className="input-group">
                                                        <input type="text" value={uploadSheets?.remarks} onChange={(e) => { setUploadSheet({ ...uploadSheets, remarks: e.target.value }) }} className="form-control" name="remarks" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Remarks" />

                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label>Upload</label>
                                                    <div>
                                                        {!loadingImportExcel ?
                                                            
                                                            <button type="button" onClick={(e) => handleSubmit(e)} className={`btn btn-info btn-label waves-effect waves-light w-100 ${uploadSheets?.file ? "" : "disabled"}`}>
                                                                <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Upload
                                                            </button> :
                                                            <button type="button" className={`btn btn-info btn-label waves-effect waves-light w-100`}>
                                                                <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Loading...
                                                            </button>
                                                        }
                                                    </div>
                                                </div>
                                                <div style={{ width: "15%" }} className='col-md-2'>
                                                    <div>
                                                        <label>Export Template</label>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={handleExcelDownload}
                                                        disabled={loading}
                                                        className={ `btn noWrap btn-success btn-label waves-effect waves-light noWrap`}>
                                                        <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                        {!loading ? "Download" : "Loading..."}
                                                    </button>
                                                </div>
                                            </div>
                                            {successMsg ?
                                            <div className=" position-relative alert alert-success mt-3" role="alert">
                                                {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                            </div>
                                            : null
                                            }
                                            {errorMsg ?
                                                <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                    {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                </div> : null
                                            }
                                        </>
                                    )}
                                    <div id="example_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer mt-4">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-6">
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="col-sm-12">
                                                <table id="example" className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed table-hover" style={{ width: '100%' }} aria-describedby="example_info">
                                                    <thead class="bg-primary text-light bg-gradient sticky-top z-1">
                                                        <tr>
                                                            <th >ID</th>
                                                            <th className="noWrap">Upload Date</th>
                                                            <th >File Name</th>
                                                            <th >Remarks</th>
                                                            {/* { decodedData?.includes(4) && ( */}
                                                                <th className=' text-center'>Action</th>
                                                            {/* )} */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(offboardingData) && offboardingData?.length >= 1 ?
                                                            <>
                                                                {offboardingData?.map((val, index) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={val?.id} className="odd">
                                                                                <td>{index + 1}</td>
                                                                                {/* <td>{formatDate(val?.updated_date)}  </td> */}
                                                                                <td className="noWrap">{val?.updated_date ? formatDate(val?.updated_date):"--"} </td>
                                                                                <td>
                                                                                    <p className="mb-0">{val?.file_name?.split("/")[val?.file_name?.split("/").length - 1]}</p>
                                                                                </td>
                                                                                <td>{val?.remarks}</td>
                                                                                {/* { decodedData?.includes(4) && ( */}
                                                                                <td className="d-flex justify-content-around  gap-2">
                                                                                        <IconButton 
                                                                                        loading={loadingDownload}
                                                                                        disabled={loadingDelete}
                                                                                        onClick={() => {downloadButton(val?.id, val?.file_name?.split("/")[val?.file_name?.split("/").length - 1])}} type='success' icon='ri-download-cloud-2-line' tooltipName='Download' tooltipPosition='bottom' />
                                                                                         {/* <button
                                                                                             type="button" class="btn btn-danger bg-danger text-light F "
                                                                                         >Loading...</button> :
                                                                                         <button
                                                                                             onClick={() => { handleDeleteExcel(val?.id) }} type="button" class="btn btn-danger bg-danger text-light waves-effect "
                                                                                         >Delete</button> */}
                                                                                         { decodedData?.includes(4) && (
                                                                                        <IconButton 
                                                                                        loading={loadingDelete}
                                                                                        disabled={loadingDownload}
                                                                                        onClick={() => {handleDeleteExcel(val?.id)}} type='danger' icon='ri-delete-bin-line' tooltipName='Delete' tooltipPosition='bottom' />
                                                                                         )}
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })

                                                                }

                                                            </>
                                                            :
                                                            <td colSpan={5}>
                                                                <NoRecords />
                                                            </td>
                                                        }


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between w-100 p-2" >
                                            <button disabled={offboardingResponse?.prev === false && loading === false}
                                                type="button" onClick={handlePrev} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                {
                                                    <small>Total Records: {totalRecords} | Total Pages: {allPages} | Current Page: {page}</small>
                                                }
                                            </div>
                                            <div className='col-md-2'>
                                                <select className="form-select">
                                                    <option value="1">Page 1</option>
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <select onChange={(e) => { handleLimitChange(e) }} className="form-select" >
                                                    <option value="10">Limit 10</option>
                                                    <option value="25">Limit 25</option>
                                                    <option value="50">Limit 50</option>
                                                    <option value="100">Limit 100</option>
                                                    <option value="200">Limit 200</option>
                                                    <option value="500">Limit 500</option>
                                                    {totalRecords > 500 ?
                                                        <option value={`${totalRecords}`}>Limit {totalRecords}</option> : null}
                                                </select>
                                            </div>
                                            <button onClick={handleNext} disabled={offboardingResponse?.next === false && loading === false}
                                                type="button" className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </section >
    );
}

export default EmployeeOffboard;